import logoWazBordo from './img/logo/LogotipoWazBordo.png'
import logoWazBlanco from './img/logo/LogotipoWazBlanco.png'
import logoWazRosa from './img/logo/LogotipoWazRosa.png'
import wazServicioLast from './img/wazServicioLast.jpg'

//logo W solo varias colores
import logoWBordoOscuro from './img/logo/LogotipoWMoradoOscuro.png'
import logoWRosa from'./img/logo/LogotipoWRosa.png'
import logoWOrange from './img/logo/LogotipoWOrange.png'

import dobleDialogo from './img/recursos/dobleDialogo.png' 
import flechasTodasDireccion from './img/recursos/flechasTodasDireccion.png' 
import phone from './img/recursos/phone.png' 

import imgPortafolioLg1 from './img/imgPortafolioLg1.png'
import imgPortafolioLg2 from './img/imgPortafolioLg2.png'
import imgPortafolioLg3 from './img/imgPortafolioLg3.png'

import imgPortafolioLg21 from './img/imgPortafolioLg21.png'
import imgPortafolioLg22 from './img/imgPortafolioLg22.png'
import imgPortafolioLg23 from './img/imgPortafolioLg23.png'

import servicioCard1 from './img/servicioCard1.png'
import servicioCard2 from './img/servicioCard2.png'
import servicioCard3 from './img/servicioCard3.png'
import servicioCard4 from './img/servicioCard4.png'
import servicioCard5 from './img/servicioCard5.png'

import aixa from './img/integrantes/aixa.png'
import trinidad from './img/integrantes/trinidad.png'
import valentina from './img/integrantes/valentina.png'
import zaraith from './img/integrantes/zaraith.png'

import servicioImg1 from './img/servicio01.png'
import servicioImg2 from './img/servicio02.png'
import servicioImg3 from './img/servicio03.png'
import servicioImg4 from './img/servicio04.png'
import bgImgServiWaz from './img/servicioWaz.png'

import iconLinkedin from './img/linkedinLogoGreen.png'

import vServicioPageMarketing from './img/recursos/vServicioPageMarketing.png'
import vServicioPageGrowth from './img/recursos/vServicioPageGrowth.png'
import vServicioPageBranding from './img/recursos/vServicioPageBranding.png'
import vServicioPageDesarrollo from './img/recursos/vServicioPageDesarrollo.png'
import vServicioPageEventos from './img/recursos/vServicioPageEventos.png'
//vectores
import navMenuBurger from './img/recursos/navMenuBurger.png'
import navMenuBurgerClose from './img/recursos/navMenuBurgerClose.png'
import vBeforeFooter from './img/recursos/vBeforeFooter.png'

export const imagenesAll = {
  navMenuBurger,
  navMenuBurgerClose,

  logoWazBordo,
  logoWazBlanco,
  logoWazRosa,

  logoWBordoOscuro,
  logoWRosa,
  logoWOrange,

  dobleDialogo,
  flechasTodasDireccion,
  phone,

  imgPortafolioLg1,
  imgPortafolioLg2,
  imgPortafolioLg3,
  iconLinkedin, 

  imgPortafolioLg21,
  imgPortafolioLg22,
  imgPortafolioLg23, 

  servicioCard1,
  servicioCard2,
  servicioCard3,
  servicioCard4,
  servicioCard5,

  aixa,
  trinidad,
  valentina,
  zaraith,

  servicioImg1,
  servicioImg2,
  servicioImg3,
  servicioImg4,
  bgImgServiWaz,
  wazServicioLast,

  vBeforeFooter, 
  
  vServicioPageMarketing,
  vServicioPageGrowth,
  vServicioPageBranding,
  vServicioPageDesarrollo,
  vServicioPageEventos,
}